import { useToast } from "@nabble/ui";
import { useState } from "react";
import { resendEmailConfirmation, type AccountEmail } from "../../../../api/accountEmails";
import { emailErrorMessage } from "./emailErrors";

/** Sends the confirmation link again; `resending` is the id of the email on its way, if any. */
export function useResendConfirmation(): { resending: string | null; resend: (item: AccountEmail) => Promise<void> } {
  const { show } = useToast();
  const [resending, setResending] = useState<string | null>(null);

  async function resend(item: AccountEmail): Promise<void> {
    setResending(item.id);
    try {
      await resendEmailConfirmation(item.id);
      show({ title: "Link sent again", text: `We sent a new confirmation link to ${item.email}.`, tone: "success" });
    } catch (err) {
      show({ title: "We couldn't send the link", text: emailErrorMessage(err, "Please try again."), tone: "danger" });
    } finally {
      setResending(null);
    }
  }

  return { resending, resend };
}
